/**
 * 랜딩 페이지 전용 훅
 * 페이지 레벨 상태 관리 및 비즈니스 로직
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
/**
 * 랜딩 페이지 커스텀 훅
 * 
 * @example
 * ```tsx
 * const { handleStartClick, scrollToSection } = useLandingPage({
 *   enableAutoScroll: true,
 *   enableAnalytics: true
 * });
 * ```
 */ export var useLandingPage = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_enableAutoScroll = options.enableAutoScroll, enableAutoScroll = _options_enableAutoScroll === void 0 ? true : _options_enableAutoScroll, _options_enableAnalytics = options.enableAnalytics, enableAnalytics = _options_enableAnalytics === void 0 ? true : _options_enableAnalytics;
    var navigate = useNavigate();
    var _useState = _sliced_to_array(useState(0), 2), scrollPosition = _useState[0], setScrollPosition = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    // 스크롤 위치 추적
    useEffect(function() {
        if (!enableAutoScroll) return;
        var handleScroll = function() {
            setScrollPosition(window.scrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, [
        enableAutoScroll
    ]);
    // 페이지 뷰 분석 추적
    useEffect(function() {
        if (!enableAnalytics) return;
        // 분석 이벤트 전송 (실제 구현에서는 분석 서비스 사용)
        console.log('[Analytics] Landing page viewed', {
            timestamp: new Date().toISOString(),
            referrer: document.referrer,
            userAgent: navigator.userAgent
        });
    }, [
        enableAnalytics
    ]);
    // CTA 버튼 클릭 핸들러 - 공통 라이브러리 사용
    var handleStartClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var urlParams, currentLang, startGeminiLogin, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        // 분석 이벤트
                        if (enableAnalytics) {
                            console.log('[Analytics] Start learning journey button clicked');
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        console.log('[LandingPage] 🚀 공통 라이브러리 startGeminiLogin 사용...');
                        // 현재 언어 가져오기 (URL params에서)
                        urlParams = window.location.pathname.split('/');
                        currentLang = urlParams[1] && /^[a-z]{2}$/.test(urlParams[1]) ? urlParams[1] : 'ko';
                        return [
                            4,
                            import('@edusense/shared-auth-core')
                        ];
                    case 2:
                        startGeminiLogin = _state.sent().startGeminiLogin;
                        return [
                            4,
                            startGeminiLogin(currentLang, 'edusense-frontend')
                        ];
                    case 3:
                        _state.sent();
                        console.log('[LandingPage] ✅ 공통 라이브러리로 OAuth 플로우 완료');
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        console.error('[LandingPage] OAuth 요청 중 에러 발생:', error);
                        alert("OAuth 요청 중 오류가 발생했습니다: ".concat(error.message));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStartClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // 로그인 버튼 클릭 핸들러 - 공통 라이브러리 사용 통일
    var handleLoginClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var urlParams, currentLang, startGeminiLogin, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        // 분석 이벤트
                        if (enableAnalytics) {
                            console.log('[Analytics] Login button clicked');
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        console.log('[LandingPage] 🔵 헤더 로그인 버튼 - 공통 라이브러리 사용...');
                        // 현재 언어 가져오기
                        urlParams = window.location.pathname.split('/');
                        currentLang = urlParams[1] && /^[a-z]{2}$/.test(urlParams[1]) ? urlParams[1] : 'ko';
                        return [
                            4,
                            import('@edusense/shared-auth-core')
                        ];
                    case 2:
                        startGeminiLogin = _state.sent().startGeminiLogin;
                        return [
                            4,
                            startGeminiLogin(currentLang, 'edusense-frontend')
                        ];
                    case 3:
                        _state.sent();
                        console.log('[LandingPage] ✅ 공통 라이브러리로 헤더 로그인 완료');
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        console.error('[LandingPage] 헤더 로그인 에러:', error);
                        alert("로그인 중 오류가 발생했습니다: ".concat(error.message));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoginClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // 특정 섹션으로 스크롤
    var scrollToSection = function(sectionId) {
        var element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            // 분석 이벤트
            if (enableAnalytics) {
                console.log('[Analytics] Scrolled to section', {
                    sectionId: sectionId
                });
            }
        }
    };
    return {
        scrollPosition: scrollPosition,
        isLoading: isLoading,
        handleStartClick: handleStartClick,
        handleLoginClick: handleLoginClick,
        scrollToSection: scrollToSection
    };
};
